// extracted by mini-css-extract-plugin
module.exports = {"btn":"ToggleButton_btn__2XmPl","btn-disabled":"ToggleButton_btn-disabled__B2mMB","img":"ToggleButton_img__J7zKb"};